import ButtonPrimary from "../../components/shared/ButtonPrimary";
import "./ContactUs.scss";

import Sparkle from "../../assets/images/sparkle.svg";

export default function ContactUs() {
	return (
		<>
			<div className="contact-us">
				<div className="contact-us-content-wrapper content-wrapper-lg">
					<div className="contact-us-card">
						<div className="contact-us-card-inner">
							<img
								src={Sparkle}
								alt="Sparkle"
								className="left-sparkle decoration"
								data-aos="zoom-in"
							/>
							<img
								src={Sparkle}
								alt="Sparkle"
								className="right-sparkle decoration"
								data-aos="zoom-in"
							/>

							<div className="contact-us-content">
								<h4 className="contact-us-title">
									Ready to explore the future of autonomous AI
									in Web3?
								</h4>
								<p className="contact-us-desc">
									Connect with us and be part of the next wave
									of blockchain innovation.
								</p>

								<div className="contact-us-btns">
									<ButtonPrimary className="contact-us-btn">
										Learn More
									</ButtonPrimary>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
